<template>
  <div class="page">
    <van-nav-bar :title="titleLable" left-arrow @click-left="casLogin?$router.go(-2):$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <!-- 遮盖层，当用户第一次打开时显示 -->
    <!-- <over-lay></over-lay> -->
    <!-- 空面板，学校没有发布实习的时候显示 -->
    <Empty v-if="pageList.length < 1"></Empty>
    <div v-else>
      <div style="height: 10px"></div>
      <!-- 顶部滑动卡片 -->
      <swiper-header :list="pageList" @change="swiperChange"></swiper-header>
      <!-- 申请栏 -->
      <transition name="slide-fade">
        <div class="apply-box" v-if="pageList[index].status == 1">
          <div class="date-box">
            <van-icon name="clock-o" />
            <div>申请时间：{{ pageList[index].sxsqkssj }}～{{ pageList[index].sxsqjssj }}</div>
          </div>
          <div class="item-box">
            <div @click="routerToApply(1)" class="item">
              <img src="../../../../assets/images/sx_sq.png" alt="" />
              <div>实习申请</div>
            </div>
            <div @click="routerToApply(2)" class="item">
              <img src="../../../../assets/images/sx_msq.png" alt="" />
              <div>免实习申请</div>
            </div>
          </div>
        </div>
        <div v-if="pageList[index].status > 2" style="padding-bottom: 50px">
          <!-- 实习状态栏 -->
          <div class="status-box">
            <van-collapse v-model="activeNames">
              <van-collapse-item name="1">
                <template #title>
                  <div class="header-name">实习岗位</div>
                </template>
                <div v-if="schoolCode=='14475'" class="sxjdb_div" @click="download" >
                  导出实习鉴定表
                </div>
                <div v-if="schoolCode=='14475'" class="sjsc_div" @click="downloadSjcs" >
                  实践手册导出
                </div>
                <div class="tip-box">
                  <div>当前单位：{{ job.qymc }}</div>
                  <div v-if="schoolCode != '10422'">当前岗位：{{ job.gwmc }}</div>
                  <div class="tip" v-if="job.isbg == 1">变更中</div>
                </div>
                <van-grid :border="false" :column-num="4">
                  <van-grid-item @click="routeLink(item)" v-for="(item, index) in statusList" :key="'status' + index">
                    <div class="nav-item">
                      <img class="icon" :src="item.icon" alt="" />
                      <div class="name">{{ item.name }}</div>
                    </div>
                  </van-grid-item>
                </van-grid>
              </van-collapse-item>
            </van-collapse>
          </div>

          <!-- 日常事务栏 -->
          <div class="menu-box">
            <van-collapse v-model="activeNames">
              <van-collapse-item name="2">
                <template #title>
                  <div class="header-name">日常事务</div>
                </template>
                <van-grid :border="false" :column-num="4">

                  <van-grid-item @click="routeLink(item)"  v-for="(item, index) in navList" :key="'nav' + index">
                    <div class="nav-item">
                      <img class="icon" :src="item.icon" alt="" />
                      <div class="name">{{ item.name }}</div>
                      <!-- <div class="tip">{{ item.tip }}</div> -->
                    </div>
                  </van-grid-item>

                </van-grid>
              </van-collapse-item>
            </van-collapse>
          </div>
          <!-- 结束实习 -->
          <div class="end-button" @click="$router.push('/internship/done')" v-if="pageList[index].jssqstatus == 0">结束实习</div>
          <div class="end-box" v-if="pageList[index].status == 4 || pageList[index].jssqstatus == 1">
            <van-collapse v-model="activeNames">
              <van-collapse-item name="3">
                <template #title>
                  <div class="header-name">结束实习附件</div>
                </template>
                <van-grid :border="false" :column-num="4" >
                  <van-grid-item >
                    <div class="nav-item" @click="$router.push('/internship/applyStatus?config=8')">
                      <img class="icon"  :src="doneImg" alt="" />
                    </div>
                  </van-grid-item>
                </van-grid>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import iApi from '@/utils/internship'
import Empty from './components/empty.vue'
import OverLay from './components/overlay.vue'
import SwiperHeader from './components/swiperHeader.vue'
export default {
  components: {
    Empty,
    OverLay,
    SwiperHeader,
  },
  data() {
    return {
      titleLable:'顶岗实习首页',
      casLogin:sessionStorage.getItem('casLogin'),
      schoolCode:'',
      pageList: [],
      index: 0,
      activeNames: ['1', '2', '3'],
      job: {
        gwmc: '',
        isbg: 0,
        qymc: '',
      },
      statusList: [
        {
          name: '实习申请',
          icon: require('../../../../assets/images/sxsq.png'),
          path: '/internship/applyStatus?config=1',
          tip: '8',
        },
        {
          name: '实习变更',
          icon: require('../../../../assets/images/sxbg.png'),
          path: '/internship/changes',
          tip: '8',
        },
        {
          name: '实习项目',
          icon: require('../../../../assets/images/sxxm.png'),
          path: '/internship/jobs',
          tip: '8',
        },
      ],
      navList: [
        {
          name: '实习考勤',
          icon: require('../../../../assets/images/sxkq.png'),
          path: '/internship/attendance',
          tip: '8',
        },
        {
          name: '免签申请',
          icon: require('../../../../assets/images/mqsq.png'),
          path: '/internship/freeSignList',
          tip: '8',
        },
        {
          name: '请假申请',
          icon: require('../../../../assets/images/qjsq.png'),
          path: '/internship/askLevelList',
          tip: '8',
        },
        {
          name: '实习日志',
          icon: require('../../../../assets/images/sxrz.png'),
          path: '/internship/daily',
          tip: '8',
        },
        {
          name: '实习周报',
          icon: require('../../../../assets/images/sxzb.png'),
          path: '/internship/weekly',
          tip: '8',
        },
        {
          name: '实习月报',
          icon: require('../../../../assets/images/sxyb.png'),
          path: '/internship/monthly',
          tip: '8',
        },
        {
          name: '实习成绩',
          icon: require('../../../../assets/images/sxcj.png'),
          path: '/internship/achievement',
          tip: '8',
        },
        {
          name: '实习总结',
          icon: require('../../../../assets/images/sxzj.png'),
          path: '/internship/summaryList',
          tip: '8',
        }
      ],

      doneImg: ''
    }
  },
  methods: {
    routerToApply(type) {
      this.$store.dispatch('setSxjhid', this.pageList[this.index].sxjhid)
      this.$store.dispatch('setIsty', this.pageList[this.index].isty)
      this.$store.dispatch('setTimeRange', [this.pageList[this.index].sxkssj, this.pageList[this.index].sxjssj])
      let path
      if (type == 1 && (this.pageList[this.index].sqstatus == 0 || this.pageList[this.index].isty == 1)) {
        path = `/internship/applyFor`
      } else if (type == 1 && this.pageList[this.index].sqstatus == 1 && this.pageList[this.index].isty == 0) {
        path = '/internship/applyStatus?config=1'
      } else if (type == 2 && this.pageList[this.index].msxsqstatus == 0) {
        path = '/internship/exemptionApplication'
      } else if (type == 2 && this.pageList[this.index].msxsqstatus == 1) {
        path = '/internship/applyStatus?config=3'
      }
      this.$router.push({ path })
    },
    routeLink(item) {
      let path = item.path
      if (this.pageList[this.index].isty && item.name == '实习申请') {
        path = '/internship/applyFor'
      }
      this.$store.dispatch('setSxjhid', this.pageList[this.index].sxjhid)
      this.$store.dispatch('setIsty', this.pageList[this.index].isty)
      this.$store.dispatch('setTimeRange', [this.pageList[this.index].sxkssj, this.pageList[this.index].sxjssj])
      this.$router.push({
        path,
      })
    },
    async getList() {
      if(this.schoolCode == '14475' || this.schoolCode == '13772'){
        this.navList.push(
          {
            name: this.schoolCode == '14475'?'三方协议':'第三方协议',
            icon: require('../../../../assets/images/sxxm.png'),
            path: '/internship/dsfxylist',
            tip: '9',
          },
          {
            name: '家长知情书',
            icon: require('../../../../assets/images/sxxm.png'),
            path: '/internship/jzzqslist',
            tip: '10',
          },
        )
        if(this.schoolCode == '13772'){
          this.navList.push(
            {
              name: '保险上传',
              icon: require('../../../../assets/images/sxxm.png'),
              path: '/internship/bxsc',
              tip: '11',
            },
          )
        }
      }

      const res = await iApi.getInternshipList()
      // console.log(res)
      this.pageList = res.data
      this.$store.dispatch('setSxjhid', this.pageList[this.index].sxjhid)
      this.getJob()
    },
    async getJob() {
      console.log(this.pageList)
      if (this.pageList[this.index].status == '3') {
        // 实习中获取实习岗位
        const res = await iApi.getInternshipJob({
          sxjhid: this.pageList[this.index].sxjhid,
          isty: this.pageList[this.index].isty,
        })
        this.job = res.data
        // 获取结束实习提交的图片

        // console.log(res)
      }
      if(this.pageList[this.index].jssqstatus == 1){
        const img = await iApi.getDoneImg({
          sxjhid: this.pageList[this.index].sxjhid,
        })
        this.doneImg = img.data.base64
      }
    },
    swiperChange(index) {
      this.index = index
      this.getJob()
    },
    async download(){
      const res = await iApi.getDoneSxjdb({
         sxjhid: this.pageList[this.index].sxjhid,
        })
      if(res.code&&res.code=='0'){
        this.$toast('下载失败！');
      } else{
        const href = URL.createObjectURL(res)
        console.log(href)
        const a = document.createElement('a')
        a.download = "实习鉴定表"
        a.href = href
        a.click()
      }

    },
    async downloadSjcs(){
      const checkRes = await iApi.checkDoneSjscdc({
         sxjhid: this.pageList[this.index].sxjhid,
         flag:'check'
      })
      if(checkRes.code != null && checkRes.code == 0){
        this.$toast(checkRes.msg);
      }else{
        const res = await iApi.getDoneSjscdc({
         sxjhid: this.pageList[this.index].sxjhid,
        })
        const href = URL.createObjectURL(res)
        console.log(href)
        const a = document.createElement('a')
        a.download = "实践手册"
        a.href = href
        a.click()
      }

    }
  },

  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.getList()
    if(this.schoolCode== '10422'){
      this.titleLable = '实习实训首页';
    }else if(this.schoolCode== '13772'){
      this.titleLable = '岗位实习';
    }
  },
}
</script>
<style lang="less" scoped>
.page {
  background: #f2f2f4;
  min-height: 100vh;
  margin-top: -50px;
}
.apply-box {
  width: 315px;
  height: 246px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 15px;
  margin: 0 auto;
  .date-box {
    width: 315px;
    height: 34px;
    background-color: rgba(73, 147, 241, 0.15);
    border-radius: 6px;
    display: flex;
    align-items: center;
    color: #2e92f9;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    .van-icon {
      margin-left: 10px;
      margin-right: 5px;
    }
  }
  .item-box {
    margin-top: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 15px;
    .item {
      height: 192px;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 64px;
        height: 67px;
      }
      div {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        margin-top: 26px;
      }
    }
  }
}
.status-box {
  width: 345px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin: 0 auto;
  .tip-box {
    width: 303px;
    height: 68px;
    background: #f2f2f4;
    border-radius: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    padding-left: 12px;
    .tip {
      position: absolute;
      right: 0;
      top: 0;
      width: 51px;
      height: 23px;
      background: #fe923f;
      border-radius: 0 8px 0 8px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      line-height: 23px;
    }
  }
}
.menu-box {
  width: 345px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin: 10px auto;
}
.header-name {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.nav-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  .icon {
    width: 42px;
    height: 42px;
  }
  .name {
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    text-align: center;
    margin-top: 10px;
  }
  .tip {
    position: absolute;
    width: 16px;
    height: 16px;
    background: #f85352;
    border: 1px solid #ffffff;
    border-radius: 8px;
    right: -6px;
    top: -6px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    line-height: 16px;
  }
}
.end-button {
  width: 345px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  line-height: 50px;
  margin: 10px auto;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.end-box {
  width: 345px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin: 0 auto;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.sxjdb_div{
  width: 120px;
  margin-left: calc(~"100% - 260px");
  height: 25px;
  background-color: #2e92f9;
  line-height: 25px;
  color: #ffffff;
  border-radius: 12px;
  text-align: center;
  margin-bottom: 5px;
  float: left;
}
.sjsc_div{
  width: 120px;
  margin-left: calc(~"100% - 120px");
  height: 25px;
  background-color: #2e92f9;
  line-height: 25px;
  color: #ffffff;
  border-radius: 12px;
  text-align: center;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/index.vue